import { StoredCapture } from "../../../types";
import { relativeTime, stackHeadline } from "../format";
import { href } from "../route";
import { LevelBadge } from "./LevelBadge";

export const CaptureRow = ({ capture, showGroupLink }: { capture: StoredCapture; showGroupLink?: boolean }) => (
  <a href={href.capture(capture.id)} className="block px-3 py-2 hover:bg-neutral-50 dark:hover:bg-neutral-800/60 border-b border-neutral-100 dark:border-neutral-800 last:border-b-0">
    <div className="flex items-center gap-2 text-xs text-neutral-500">
      <LevelBadge level={capture.level} />
      <span className="font-mono">{capture.source}</span>
      {capture.lambdaName && <span className="font-mono truncate">{capture.lambdaName}</span>}
      {capture.runtime === "browser" && capture.location && <span className="truncate max-w-[20rem]">{capture.location}</span>}
      <span className="flex-1" />
      {capture.userId && <span>user {capture.userId}</span>}
      {capture.status !== "open" && <span className="italic">{capture.status}</span>}
      {capture.floodSampled && <span className="rounded bg-amber-100 text-amber-800 dark:bg-amber-900/50 dark:text-amber-200 px-1" title="Kept as a 1-in-N sample while the group was over the flood limit">flood sample</span>}
      {capture.suppressedBefore && <span className="rounded bg-amber-100 text-amber-800 dark:bg-amber-900/50 dark:text-amber-200 px-1" title="Client rate limit: this many were console-logged instead of sent before this one">+{capture.suppressedBefore} suppressed</span>}
      <span title={`received ${capture.receivedAt}\nhappened ${capture.timestamp}`}>{relativeTime(capture.receivedAt)}</span>
    </div>
    <div className="mt-0.5 text-sm truncate">
      {capture.error?.name && <span className="font-semibold">{capture.error.name}: </span>}
      {capture.message}
    </div>
    {stackHeadline(capture.error?.stack) && (
      <div className="text-xs text-neutral-400 font-mono truncate">{stackHeadline(capture.error?.stack)}</div>
    )}
    {showGroupLink && (
      <div className="text-[11px] text-neutral-400">group {capture.groupId.slice(0, 8)}</div>
    )}
  </a>
);

// Text search over the fields a person would actually type.
export const matchesQuery = (c: StoredCapture, q: string | undefined) => {
  if (!q) return true;
  const hay = [c.message, c.error?.name, c.error?.message, c.error?.stack, c.source, c.lambdaName, c.location, c.userId, c.user?.username, c.flowId, JSON.stringify(c.tags ?? {})]
    .filter(Boolean)
    .join("\n")
    .toLowerCase();
  return q.toLowerCase().split(/\s+/).filter(Boolean).every((word) => hay.includes(word));
};
